export const ENVIRONMENT = {
  version: '36c9b4e',
  baseUrls: {
    id: ['localhost:4200', 'v3uat.modalku.co.id', 'xyz.modalku.co.id'],
    my: [
      'localhost:4300',
      'v3uat.fundingsocieties.com.my',
      'xyz.fundingsocieties.com.my',
    ],
    sg: [
      'localhost:4400',
      'v3uat.fundingsocieties.com',
      'xyz.fundingsocieties.com',
    ],
    th: ['v3uat.fundingsocieties.co.th'],
  },
  apiBase: 'https://api-uat.modalku.co.id',
  environment_name: 'uat-id',
  enableSendingMixPanelEvents: true,
  sentry_logging: true,
  mixpanel: {
    token: '64cc310eb441820f75a4cc86047d29f6',
  },
  cleverTap: {
    id: {
      projectId: 'TEST-5WK-898-8Z6Z',
    },
    my: {
      projectId: 'TEST-77Z-898-8Z6Z',
    },
    sg: {
      projectId: 'TEST-4W5-9WK-8Z6Z',
    },
  },
  intercom: {
    id: {
      appId: 'v0ck52by',
      hashCode: 'SJtXNeaAgdNBu0JvvuWl0D5CGMix4MgbTI-EMmHq',
    },
    sg: {
      appId: 'w2vzp48t',
      hashCode: '-FEM1Nl66ErV5wodUiqf_lWYy-cGj-GXQQMPTR6e',
    },
    my: {
      appId: 'kpac1cru',
      hashCode: 'wGD2Ca8EwjXdsAlMxkHLef3-bDc4tyRnZBEzDXtJ',
    },
    th: {
      appId: 'tab54l5i',
      hashCode: 'pUxf7pSRJPXtzuq2cLiIfXTT6R4B5jMyo53mFbW9',
    },
  },
  vwo: {
    my: {
      accountId: '',
    },
  },
  cookieYesScript: {},
  myinfo: {
    borrower: {
      clientId: 'STG-201505169M-BORROWER',
    },
    investor: {
      clientId: 'STG-201505169M-INVESTOR',
    },
    callbackUrl: 'https://v3staging.fundingsocieties.com/myinfo_callback',
  },
  governmentBondTradeable: {
    link: 'http://167.99.72.93/',
  },
  production: true,
  boltLinkXero: 'https://web-uat.fsbolt.com/web/business-information',
  yearInReviewLink: 'https://staging-yearinreview.fundingsocieties.com',
  service: {
    authentication: 'https://api-uat.modalku.co.id',
    bond: 'https://api-uat.modalku.co.id/api/v1/esbn',
    bankIntegrationService: 'https://api-uat.modalku.co.id/api/bis',
    crowdfunding: 'https://api-uat.modalku.co.id/api/cfp',
    document: 'https://api-uat.modalku.co.id/api/docs_management/v3/document',
    finance: 'https://api-uat.modalku.co.id/api/fs',
    financeV2: 'https://api-uat.modalku.co.id/api/fs/v2',
    finance_public: 'https://api-uat.modalku.co.id/api/fs/p',
    loan: 'https://api-uat.modalku.co.id/api/ln',
    loanV2: 'https://api-uat.modalku.co.id/api/ln/v2',
    loyalty: 'https://api-uat.modalku.co.id/api/v1/loyalty',
    member: 'https://api-uat.modalku.co.id/api/ms',
    note: 'https://api-uat.modalku.co.id/api/ns',
    two_fa: 'https://api-uat.modalku.co.id/api/2fa',
    public_identifier: '/p',
    v2: 'https://api-uat.modalku.co.id/api/v2',
    slack: 'https://microloan.fundingasiagroup.com/slack/send',
    payment_service: 'https://api-uat.modalku.co.id/api/ps',
    curlec_payment: 'https://mydd.mydirectdebit.my/new-instant-pay',
    myinfo: 'https://myinfosgstg.api.gov.sg/test/v2',
    platform_my_info: 'https://api-uat.modalku.co.id/api/myinfo',
    facility: 'https://api-uat.modalku.co.id/api/facility/v2',
    bbs: 'https://api-uat.modalku.co.id/api/bbs/ext',
    ees: 'https://api-uat.modalku.co.id/api/ees/ext',
  },
  launch_darkly_client_id: '5da02810c00cf208a2828a05',
  // https://funding-societies.sentry.io/settings/projects/investor-borrower-webapp-as3/keys/d10af6bea40a4b00aaac0d2d3152c87e/
  sentryDsn:
    'https://d10af6bea40a4b00aaac0d2d3152c87e@o103441.ingest.sentry.io/4504806303793152',
  microLoanURL: {
    sg: 'https://apply-uat.fundingsocieties.com/ml?source=main-website-login',
    my: 'https://apply-uat.fundingsocieties.com.my/?source=main-website-login',
  },
  silkRoadURL: {
    id: 'https://uat-scfs.fundingasiagroup.com/login',
  },
  esignPortalURL: {
    id: 'https://apply-uat.modalku.co.id/tanda-tangan',
  },
  verificationPortalURL: {
    id: 'https://apply-uat.modalku.co.id/verifikasi',
  },
  fusionAuth: {
    baseUrl: 'https://fsmk-uat.fusionauth.io',
    clientId: {
      sg: '86e01e01-61be-4030-a172-2c05d13fec04',
      th: '88c26801-f815-45bd-9b2d-81d15068e67a',
      my: 'e8f46168-316a-4a39-977f-e59b8c81a545',
      id: 'b35cd4e6-d100-4302-be28-b3d29b869783',
    },
  },
  reCaptchaSiteKey: '6Ld4mwMqAAAAAPJHeaiT9BqLIoT-ZFnfCInNFL0m',
};
